import { NavaidModel } from "./navaid";

export class FomCheckModel{
  navaids : NavaidModel[] = [];
}
